module.exports = function sortBy () {
  var args = Array.prototype.concat.apply([], arguments) || []

  return function (a, b) {
    var n = 0
    while (n < args.length) {
      if (typeof args[n] === 'function') {
        var result = args[n](a, b)
      } else {
        // 解析表达式
        var parsedExpression = parseExpression(args[n])
  
        var result = compare(
          getPropertyValue(a, parsedExpression.prop),
          getPropertyValue(b, parsedExpression.prop),
          parsedExpression.desc
        )
      }

      // 如果比较不同则直接返回结果
      if (result !== 0) {
        return result
      // 如果比较结果相同，且是最后一组，直接返回结果
      } else if (n === args.length - 1) {
        return result
      }

      // 如果比较结果相同且不是最后一组，继续比较下一组条件
      n++
    }
  }
}

/**
 * 表达式解析器
 * 
 * @param {string} expression - 表达式
 * @returns {object} - 解析结果，prop代表属性值，desc代表是否降序
 */
function parseExpression (expression) {
  var pattern = /^(-)?(.*)/
  var matcher = pattern.exec(expression)

  return {
    prop: matcher[2],
    desc: matcher[1] === '-'
  }
}

/**
 * 排序算法
 * 
 * @param {*} a - 第一个值
 * @param {*} b - 第二个值
 * @param {boolean} desc - 是否降序
 * @returns {number}
 */
function compare (a, b, desc) {
  if (a === b) return 0

  return a < b
    ? desc ? 1 : -1
    : desc ? -1 : 1
}

/**
 * 获取对象对应属性的值
 * 
 * @param {object} obj - 对象
 * @param {string} property - 属性名
 */
function getPropertyValue (obj, property) {
  return eval('obj.' + property)
}
